/* RESPONSIBLE TEAM: team-proactive-support */
import Model from '@ember-data/model';

// This model is used where we need a placeholder Ember Data model for the polymorphic relation to the content object.
export default class ContentObject extends Model {}
